import { IntegrationVersion } from 'api/usePublisherIntegrationTest';
import { FormikProps } from 'formik';

import { EApiVersion } from '../DeveloperSettings.types';

interface IGrantAwardFormValues {
  ordersReportingApiUrl: string;
  awardingV2ApiUrl: string;
  selectedAwardingVersion: string;
}

interface IUseGrantAwardTestModalParams {
  grantAwardForm: FormikProps<IGrantAwardFormValues>;
  isAwardingV2FeatureFlagOn: boolean;
}

interface IGrantAwardTestModalResult {
  version: IntegrationVersion;
  callbackUrl: string;
}

const getTestModalVersion = (
  isAwardingV2FeatureFlagOn: boolean,
  selectedVersion: string
): IntegrationVersion => {
  if (isAwardingV2FeatureFlagOn && selectedVersion === EApiVersion.V2) {
    return IntegrationVersion.V2;
  }
  return IntegrationVersion.V1;
};

const getTestModalCallbackUrl = (
  isAwardingV2FeatureFlagOn: boolean,
  selectedVersion: string,
  v2Url: string,
  v1Url: string
): string => {
  if (isAwardingV2FeatureFlagOn && selectedVersion === EApiVersion.V2) {
    return v2Url;
  }
  return v1Url;
};

export const useGrantAwardTestModal = ({
  grantAwardForm,
  isAwardingV2FeatureFlagOn
}: IUseGrantAwardTestModalParams): IGrantAwardTestModalResult => {
  const version = getTestModalVersion(
    isAwardingV2FeatureFlagOn,
    grantAwardForm.initialValues.selectedAwardingVersion
  );

  const callbackUrl = getTestModalCallbackUrl(
    isAwardingV2FeatureFlagOn,
    grantAwardForm.initialValues.selectedAwardingVersion,
    grantAwardForm.initialValues.awardingV2ApiUrl,
    grantAwardForm.initialValues.ordersReportingApiUrl
  );

  return {
    version,
    callbackUrl
  };
};
